import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'claims-expandable-cell',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './expandable-cell.html',
  styleUrl: './expandable-cell.scss',
})
export class ExpandableCellComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public cellValue = '';
  public isExpanded = false;
  public needsExpansion = false;
  private readonly maxLength: number = 100;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.cellValue = params.value || '';
    this.needsExpansion = this.cellValue.length > this.maxLength;
  }

  public refresh(params: ICellRendererParams): boolean {
    return false;
  }

  public toggleExpand(event: MouseEvent): void {
    event.stopPropagation();
    this.isExpanded = !this.isExpanded;
    
    setTimeout(() => {
      if (this.params.api) {
        this.params.api.resetRowHeights();
      }
    }, 0);
  }
}
